function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import assetResolver, { assetKeys } from 'mosaic-assets-resolver';
import { findChildByType } from '../internals/utils/reactHelpers';
import SovosHeroBannerTitle from '../sovos-hero-banner-title';
import SovosHeroBannerSubtitle from '../sovos-hero-banner-subtitle';
import SovosHeroBannerStatus from '../sovos-hero-banner-status';
import { contentSidePadding } from '../internals/page-layout/contentPadding';
const DEFAULT = 'default';
const DARK = 'dark';
const SUCCESS = 'success';
const ERROR = 'error';
const WARNING = 'warning';
const INPROGRESS = 'inprogress';
const Root = styled('div')(_ref => {
  let {
    theme: {
      breakpoints,
      spacing,
      palette
    }
  } = _ref;
  return {
    backgroundColor: palette.primary.dark,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: 'row',
    height: 200,
    justifyContent: 'space-between',
    ...contentSidePadding(breakpoints, spacing),
    '& .sovosHeroBanner__leftColumn': {
      display: 'flex',
      flexDirection: 'column'
    }
  };
});
const {
  heroBanners
} = assetKeys;
const SovosHeroBanner = _ref2 => {
  let {
    backgroundImage,
    children,
    className,
    color = DEFAULT,
    style = {},
    ...rest
  } = _ref2;
  const title = findChildByType(children, SovosHeroBannerTitle);
  const subtitle = findChildByType(children, SovosHeroBannerSubtitle);
  const status = findChildByType(children, SovosHeroBannerStatus);
  let image;
  if (backgroundImage) {
    image = backgroundImage;
  } else {
    switch (color) {
      case DARK:
        image = assetResolver.heroBanners(heroBanners.colors.dark);
        break;
      case ERROR:
        image = assetResolver.heroBanners(heroBanners.colors.error);
        break;
      case SUCCESS:
        image = assetResolver.heroBanners(heroBanners.colors.success);
        break;
      case WARNING:
        image = assetResolver.heroBanners(heroBanners.colors.warning);
        break;
      case INPROGRESS:
        image = assetResolver.heroBanners(heroBanners.colors.inProgress);
        break;
      case DEFAULT:
        image = assetResolver.heroBanners(heroBanners.colors.default);
        break;
      default:
        image = undefined;
    }
  }
  const bannerStyle = image ? {
    backgroundImage: "url(".concat(image, ")"),
    ...style
  } : {
    backgroundColor: color,
    ...style
  };
  return /*#__PURE__*/React.createElement(Root, _extends({
    className: clsx('sovosHeroBanner', className),
    "data-testid": "sovosHeroBanner",
    style: bannerStyle
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "sovosHeroBanner__leftColumn"
  }, title, subtitle), /*#__PURE__*/React.createElement("div", {
    className: "sovosHeroBanner__rightColumn"
  }, status));
};
SovosHeroBanner.propTypes = {
  /**
   * Background Image
   */
  backgroundImage: PropTypes.string,
  /**
   * The content of the hero banner. Should be wrapped with
   * `SovosHeroBannerTitle`, `SovosHeroBannerSubtitle`, and `SovosHeroBannerStatus`
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired,
  /**
   * Override or extend the styles applied to the component
   */
  className: PropTypes.string,
  /**
   * Array of color options: default, dark, success, error, warning, and inprogress
   */
  color: PropTypes.oneOfType([PropTypes.oneOf([DEFAULT, DARK, SUCCESS, ERROR, WARNING, INPROGRESS]), PropTypes.string]),
  /**
   * Inline styles applied to the root element
   */
  style: PropTypes.object
};
export default SovosHeroBanner;